/*
 * @Author: Teemo Ding
 * @Date: 2022-03-23 14:45:01
 * @LastEditTime: 2023-03-21 11:18:41
 * @LastEditors: Jack Deng
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Customer/FapiaoInfo.tsx
 */
import { Icon } from '@/src/tools/icon';
import { useRequest } from 'ahooks';
import React, { Fragment } from 'react';
import { deleteInvoice, getInvoice, saveInvoice } from 'src/request/order';
import { InvoiceType } from 'src/types/common/invoice';
import EditFapiaoInfo from '../EditFapiaoInfo';
import ModalHoc from 'src/constrains/ModalHOC';
import { Form } from 'antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const FapiaoInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent, setWidth },
    disabled,
    customer,
    orderUuid,
    invoice,
    reLoadOrderPage,
    changeCustomer,
    setInvoice,
    // handleApply,
  } = props;
  const [form] = Form.useForm();
  const { run: _deleteInvoice } = useRequest(() => deleteInvoice(orderUuid), {
    manual: true,
    onSuccess: () => {
      handleCancel();
      form.resetFields();
      reLoadOrderPage();
    },
  });
  const { run: _getInvoice } = useRequest(() => getInvoice(orderUuid), {
    manual: true,
    onSuccess: (res) => {
      handleInvoiceModal(res);
    },
  });

  const { run: _saveInvoice } = useRequest(
    (data) => saveInvoice(orderUuid, data),
    {
      manual: true,
      onSuccess: () => {
        handleCancel();
        reLoadOrderPage();
      },
    },
  );

  const handleInvoiceModal = (invoice) => {
    form.setFieldsValue({ ...invoice });
    setWidth(600);
    setShowModal(true);
    setModalTitle(
      getI18n('allOrders.createneworder.component_customer_FapiaoInfo'),
    );
    setModalContent(null);
    setModalContent(
      <EditFapiaoInfo
        {...invoice}
        formRef={form}
        onCancel={handleCancel}
        onConfirm={(values) => {
          const cb = () => {
            handleCancel();
            // if (reLoadOrderPage) reLoadOrderPage();
          };
          const cbCreat = (data) => {
            setInvoice(data);
            changeCustomer({
              invoice: data,
            });
            handleCancel();
          };
          if (customer) {
            return new Promise((resolve, reject) => {
              resolve({
                response: { status: 200, data: { payload: values } },
                cb: cbCreat,
              });
            });
          } else {
            return _saveInvoice(values).then((res) => {
              return { response: { status: 200, data: res }, cb };
            });
          }
        }}
        onDiscard={handleCancel}
        onDelete={() => {
          const cb = () => {
            handleCancel();
            // if (reLoadOrderPage) reLoadOrderPage();
          };
          const cbCreat = () => {
            setInvoice();
            changeCustomer({
              invoice: null,
            });
            // handleApply();
            handleCancel();
          };
          if (customer) {
            return new Promise((resolve, reject) => {
              resolve({
                response: { status: 200, data: { payload: {} } },
                cb: cbCreat,
              });
            });
          } else {
            return _deleteInvoice().then((res) => {
              return { response: res, cb };
            });
          }
        }}
      />,
    );
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  return (
    <Fragment>
      <div className={css.customItem}>
        <h3>
          {getI18n('allOrders.orderDetail.component_customer_FapiaoInfo')}
          {disabled ? (
            <Icon className={css.disable} type='iconedit' />
          ) : (
            <Icon
              type='iconedit'
              onClick={() => {
                return customer ? handleInvoiceModal(invoice) : _getInvoice();
              }}
            />
          )}
        </h3>
        <span>
          {(invoice || {}).type
            ? (invoice || {}).type === InvoiceType.Individual
              ? getI18n(
                  'allOrders.createneworder.component_customer_PersonalFapiao',
                )
              : getI18n(
                  'allOrders.createneworder.component_customer_BusinessFapiao',
                )
            : '-'}
        </span>
        {(invoice || {}).type && (
          <Fragment>
            <h3>Email</h3>
            <span>{(invoice || {}).email || '-'}</span>
          </Fragment>
        )}
        {(invoice || {}).type === InvoiceType.Company && (
          <Fragment>
            <h3>
              {getI18n(
                'allOrders.createneworder.component_customer_Fapiao_title',
              )}
            </h3>
            <span>{(invoice || {}).title || '-'}</span>
          </Fragment>
        )}
        {(invoice || {}).type === InvoiceType.Company && (
          <Fragment>
            <h3>
              {getI18n(
                'allOrders.createneworder.component_customer_Fapiao_taxFIleNum',
              )}
            </h3>
            <span>{(invoice || {}).tfn || '-'}</span>
          </Fragment>
        )}
        {(invoice || {}).type && (
          <Fragment>
            <h3>
              {getI18n(
                `allOrders.orderDetail.component_customer_editfapiaoinfo_fapiaostatus`,
              )}
            </h3>
            {(invoice || {}).beenGenerated && (invoice || {}).beenDelivered && (
              <span>
                {getI18n(
                  'allOrders.createneworder.component_customer_Fapiao_generated&delivered',
                )}
              </span>
            )}
            {(invoice || {}).beenGenerated &&
              !(invoice || {}).beenDelivered && (
                <span>
                  {getI18n(
                    'allOrders.createneworder.component_customer_Fapiao_generated',
                  )}
                </span>
              )}
            {!(invoice || {}).beenGenerated &&
              (invoice || {}).beenDelivered && (
                <span>
                  {getI18n(
                    'allOrders.createneworder.component_customer_Fapiao_delivered',
                  )}
                </span>
              )}
            {!(invoice || {}).beenGenerated &&
              !(invoice || {}).beenDelivered && <span>-</span>}
          </Fragment>
        )}
        {(invoice || {}).type && (
          <Fragment>
            <h3>Remarks</h3>
            <span>{(invoice || {}).remarks || '-'}</span>
          </Fragment>
        )}
      </div>
      <div className={css.splitLine}></div>
    </Fragment>
  );
};

export default ModalHoc(FapiaoInfo);
